import PropTypes from 'prop-types'
import React from 'react'

const DocumentiHelper = ({ onClick, flowType }) => (
  <div className={'documenti-helper'} onClick={onClick}>
    <i className={'icon-info'} />
    <span>
      {flowType === 'buy-financing' &&
        "Verifica che le foto / scansioni siano ben leggibili per evitare ritardi nell'erogazione del prestito."}
      {flowType === 'rent' &&
        'Verifica che le foto / scansioni siano ben leggibili per evitare ritardi.'}
      {flowType === 'buy-bank' &&
        'Verifica che le foto / scansioni siano ben leggibili per evitare ritardi.'}
    </span>
  </div>
)

DocumentiHelper.propTypes = {
  onClick: PropTypes.func,
}

export default DocumentiHelper
